import React from "react";
import { ExpressionBuilder } from "../ExpressionBuilder";
import { expressionStoryData } from "../Testing/ExpressionData";
import {
    getExistsSimpleRule,
    getIfElseSimpleRule,
    getIfSimpleRule,
    getLogicExpression,
    getLogicExpressionElseIf,
    getLogicExpressionElseIfElseWithSub,
    getLogicExpressionElseIfElseWithSubWithBlanks,
    getLogicExpressionResultAtEnd,
    getLogicExpressionResultElseIfAtEnd,
    isFalseSimpleRule,
    isTrueSimpleRule,
    lessThanEqualToSimpleRule,
    lessThanSimpleRule,
    notSimpleRule,
} from "../Testing/LogicData";
import { IfThenExpression } from "../../rule-engine-core/Expressions/Expressions/Logic/IfThenExpression";
import { getFilledDataDefinition } from "../../rule-engine-core/Common/Data/DataTestData";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";

export const ExpressionLogicStories = [
    new StoryNode(
        () => {
            let exp = getLogicExpression();

            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpression();
            (exp.expression as IfThenExpression).showElseAsDefault = true;

            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then Default",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIf();

            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then Default",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIf();
            exp = getLogicExpressionElseIf();

            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then Else If",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIf();
            exp.inputData = expressionStoryData;
            (exp.expression as IfThenExpression).thenText = "Bonus Paid Is";

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then Else If (Replaced)",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIf();
            exp.inputData = expressionStoryData;
            (exp.expression as IfThenExpression).showElseAsDefault = true;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then Else If (Default)",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIf();
            exp.inputData = expressionStoryData;
            (exp.expression as IfThenExpression).showElseAsDefault = true;
            (exp.expression as IfThenExpression).thenText = "company pays";
            (exp.expression as IfThenExpression).defaultText = "everyone else gets";

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then Else If (Default - Changed Text)",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIfElseWithSub();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then Else If Else With Sub",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIfElseWithSubWithBlanks();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then Else If Else With Sub With Blanks",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpressionResultAtEnd();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then Results At End",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpressionResultElseIfAtEnd();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Then Results Else At End",
    ),

    new StoryNode(
        () => {
            let exp = getIfSimpleRule();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Simple Rule",
    ),

    new StoryNode(
        () => {
            let exp = getIfSimpleRule();
            exp.inputData = expressionStoryData;
            (exp.expression as IfThenExpression).showSimpleReturn = false;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Simple Rule - No Return",
    ),

    new StoryNode(
        () => {
            let exp = getIfElseSimpleRule();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Else Simple Rule",
    ),

    new StoryNode(
        () => {
            let exp = getIfElseSimpleRule();
            exp.inputData = expressionStoryData;
            (exp.expression as IfThenExpression).showSimpleReturn = false;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "If Else Simple Rule No Return",
    ),

    new StoryNode(
        () => {
            let exp = getExistsSimpleRule();
            exp.inputData = () => {
                return getFilledDataDefinition();
            };

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "Exists Read Only",
    ),

    new StoryNode(
        () => {
            let exp = getExistsSimpleRule();
            exp.inputData = getFilledDataDefinition();

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "Exists Writable",
    ),

    new StoryNode(
        () => {
            let exp = isFalseSimpleRule();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "Is False",
    ),

    new StoryNode(
        () => {
            let exp = isTrueSimpleRule();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "Is True",
    ),

    new StoryNode(
        () => {
            let exp = lessThanSimpleRule();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "Less Than",
    ),

    new StoryNode(
        () => {
            let exp = lessThanEqualToSimpleRule();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "Less Than Equal To",
    ),

    new StoryNode(
        () => {
            let exp = notSimpleRule();
            exp.inputData = expressionStoryData;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Logic",
        "Not",
    ),
];
